const Wing = ({ id }) => (
  <svg viewBox="0 0 64 60" className="bfly w-full h-full" aria-hidden="true">
    <defs><linearGradient id={id} x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#E9BDB4" /><stop offset=".55" stopColor="#C47F78" /><stop offset="1" stopColor="#A9615B" /></linearGradient></defs>
    <g className="wl"><path d="M31 30 C20 6, 2 4, 6 18 C8 26, 18 28, 31 30 Z M31 31 C18 33, 8 42, 14 50 C20 55, 28 44, 31 31 Z" fill={`url(#${id})`} fillOpacity=".55" stroke="#B8746D" strokeWidth=".8" /></g>
    <g className="wr"><path d="M33 30 C44 6, 62 4, 58 18 C56 26, 46 28, 33 30 Z M33 31 C46 33, 56 42, 50 50 C44 55, 36 44, 33 31 Z" fill={`url(#${id})`} fillOpacity=".55" stroke="#B8746D" strokeWidth=".8" /></g>
    <path d="M32 22 L32 44" stroke="#8E4E49" strokeWidth="1.6" strokeLinecap="round" /><path d="M32 22 C30 16, 27 13, 25 12 M32 22 C34 16, 37 13, 39 12" stroke="#8E4E49" strokeWidth=".7" fill="none" />
  </svg>
);

const FLIGHTS = [
  { size: 34, anim: "drift1 38s linear infinite", delay: "0s" },
  { size: 24, anim: "drift2 46s linear infinite", delay: "-12s" },
  { size: 28, anim: "drift1 52s linear infinite", delay: "-30s" },
  { size: 20, anim: "drift2 60s linear infinite", delay: "-40s" },
];

export const Butterflies = () => (
  <div className="pointer-events-none fixed inset-0 z-[35] overflow-hidden motion-reduce:hidden" data-testid="butterflies">
    {FLIGHTS.map((f, i) => (
      <div key={i} className="absolute top-0 left-0" style={{ width: f.size, height: f.size, animation: f.anim, animationDelay: f.delay }}>
        <Wing id={`bg${i}`} />
      </div>
    ))}
  </div>
);

export const Butterfly = ({ className = "", id = "bf" }) => <div className={className} style={{ animation: "hover 6s ease-in-out infinite" }}><Wing id={id} /></div>;
